export default __webpack_public_path__ + "static/media/Medicare-Green.b03fdb99.png";